import { createPageApp } from '@/lib/createPageApp'
import ChooseCoursePage from './ChooseCoursePage.vue'

createPageApp(ChooseCoursePage).mount()
